import getRandomColor from "@/utils/getRandomColor";
import { styled } from "@monolith-forensics/monolith-ui";

type Shape = "circle" | "square";

const StyledContainer = styled.div<{ color: string; shape?: Shape }>`
  border-radius: ${({ shape }) => (shape === "circle" ? "50%" : "4px")};
  height: 18px;
  width: 18px;
  background-color: ${({ color }) => color || "#000000"};
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  font-size: 8px;
  color: white;
`;

export type AvatarProps = {
  style?: React.CSSProperties;
  color?: string;
  text: string;
  shape?: Shape;
  id?: number;
};

const getLettersFromText = (text: string) => {
  const words = text.split(" ");
  if (words.length > 1) {
    return words[0].charAt(0) + words[1].charAt(0);
  }
  return words[0].charAt(0);
};

export const UserAvatar: React.FC<AvatarProps> = ({
  style = {},
  color,
  text,
  shape = "circle",
  id,
}) => {
  return (
    <StyledContainer
      color={color || getRandomColor(id || text, id || text.length)}
      shape={shape}
      style={{
        ...style,
      }}
    >
      {getLettersFromText(text)}
    </StyledContainer>
  );
};
